import 'rxjs/add/operator/map';

import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MdDialog, MdSort } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { AppMessage } from './../../Common/appMessage';
import { TableDataSource } from './../../Common/md-table';
import { AppGlobals } from './../../Common/Services/app.global';
import { SharedService } from './../../Common/Services/shared.service';
import { Utility } from './../../Common/Services/utility';
import { DialogConfirmComponentComponent } from './../dialog-confirm-component/dialog-confirm-component.component';
import { AdmManageUniversalOperationalHoursService } from './adm-manage-universal-operational-hours.service';
import { FeatureFlagService, ToggleName } from 'app/Common/Services/feature-flag.service';

@Component({
  selector: 'app-adm-manage-universal-operational-hours',
  templateUrl: './adm-manage-universal-operational-hours.component.html',
  styleUrls: ['./adm-manage-universal-operational-hours.component.css'],
  providers: [AdmManageUniversalOperationalHoursService, FeatureFlagService]
})
export class AdmManageUniversalOperationalHoursComponent implements OnInit, OnDestroy {
  @ViewChild(MdSort) sort: MdSort;

  isEditForm: boolean = true;
  form: FormGroup;
  dataSource: TableDataSource | null;
  paginationInfo: any;
  role: string;
  conflictData: any;
  conflictPaginationInfo: any;
  disableField: boolean = true;
  dataSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]); // store all grid data
  displayedColumns = ['day', 'fromDateTime', 'toDateTime', 'occasion', 'action'];

  constructor(private featureFlags: FeatureFlagService, private _sharedService: SharedService, public _utility: Utility, public _appGlobal: AppGlobals, private _admManageUniversalOperationalHoursService: AdmManageUniversalOperationalHoursService,
    private _appMessage: AppMessage, public _dialog: MdDialog) {
    this.form = new FormGroup({
      startDay: new FormControl('', Validators.required),
      startTime: new FormControl('', Validators.required),
      endDay: new FormControl('', Validators.required),
      endTime: new FormControl('', Validators.required)
    });
    this.form.disable();
    this.paginationInfo = { totalRecords: -1 }; // Set initial value of Totalrecords property
    this.role = this._utility.getUserRole();
  }

  private redirect(): void {
    window.location.assign("/ies/internal/universal-hours-of-operation");
  }

  ngOnInit() {
    this.featureFlags.on("ready", () => {
      if (this.featureFlags.isEnabled(ToggleName.ENABLE_UNIVERSAL_HOURS_OF_OPERATION_REDIRECT)) {
        this.redirect();
      }
    });
    this.featureFlags.on("update", () => {
      if (this.featureFlags.isEnabled(ToggleName.ENABLE_UNIVERSAL_HOURS_OF_OPERATION_REDIRECT)) {
        this.redirect();
      }
    });
    this.featureFlags.start();
    this.setFormData();
    this.form.valueChanges
      .debounceTime(100)
      .distinctUntilChanged()
      .subscribe(form => {
        if (this.form.dirty && !this.form.disabled) {
          this._utility.setTxnStatus(true);
        }
        this.validateDay();
      });
  }

  ngOnDestroy(): void {
      this.featureFlags.stop();
  }

  //validation implemented - end day cannot be less than or equal to start day
  validateDay() {
    let controls = this.form.controls;
    let startDayId = controls.startDay.value.Id;
    let endDayId = controls.endDay.value.Id;
    let endTime = controls.endTime.value;
    let startTime = controls.startTime.value;
    if (startDayId && endDayId) {
      if (endDayId <= startDayId) {
        controls.endDay.setErrors({ invalid: true });
      }
      else {
        controls.endDay.setErrors(null);
      }
    }
  }

  setFormData() {
    let selectedStartDate;
    let data;
    this._admManageUniversalOperationalHoursService.getUniversalOperationalHours().subscribe(
      (response: any) => {
        this._utility.onSuccessCallback(response, null, () => {
          data = response.response;
          const selectedStartDate = this._utility.weekdays.find(weekdays => weekdays.Id === data.startDay);
          const selectedEndDate = this._utility.weekdays.find(weekdays => weekdays.Id === data.endDay);
          data.startDay = selectedStartDate;
          data.endDay = selectedEndDate;
          (<FormGroup>this.form)
            .setValue(data, { onlySelf: true });
          this._utility.disableEnableForm(this.form, true);
          //this.form.disable();
        });
      },
      error => {
        this._utility.onErrorCallback(error)
      });


  }
  onEdit() {
    this.form.enable();
    this.isEditForm = false;
    this.disableField = false;
  }

  //action to be performed when hours are added
  onAdd(): void {
    if (this.form.invalid) return;

    let formData = this.form.getRawValue();
    formData = this._utility.manageFormDataforSave(formData);
    formData.startDay = formData.startDay.Id;
    formData.endDay = formData.endDay.Id;
    this.hideConflictGrid(); // Hide conflict Grid when You try to add any new closure
    //display confimation box
    let confimrMsg = this._appMessage.getItem['UMsg00069'];// "Select yes to update universal hours of operation."
    let confirmDialogMsgModel = {
      modelType: "CONFIRMATION",
      msgTitle: this._appMessage.getItem['Common007'],//'Are you sure?',
      msg: confimrMsg,
      isConfirmBox: true,
      confirmBtnCaption: this._appMessage.getItem['Common014'],//'Yes',
      cancelBtnCaption: this._appMessage.getItem['Common015'],//'No'
    };
    let confirmDialogMsgRef = this._dialog.open(DialogConfirmComponentComponent,
      {
        data: confirmDialogMsgModel
      });
    confirmDialogMsgRef.afterClosed().subscribe(result => {
      //when selected ok from the confimation box
      if (result == "1") {
        this._utility.addLoaderCount();
        this._admManageUniversalOperationalHoursService.updateUniversalOperationalHours(formData).subscribe((response: any) => {
          // when conflict occur,response code is E1151
          if (response.responseCode && response.responseCode.toUpperCase() == "E1151") {
            this._utility.removeLoaderCount();
            if (response.response && response.response.results && response.response.paginationInfo) {
              this.conflictData.message = this._appMessage.getItem["UMsg00070"];
              this.conflictData.response = response.response;
              this.conflictPaginationInfo = response.response.paginationInfo; // update paginaton info
            }
            return;
          } else {
            this._utility.onSuccessCallback(response, this._appMessage.getItem['UMsg00030'], () => {
              this.setFormData(); // load record after new record is added
              this.isEditForm = true;
              this.disableField = true;
              this._utility.disableEnableForm(this.form, true);
              this._utility.clearTxnStatus(); // close confirm box for FORM changes
            });
          }
        }, error => this._utility.onErrorCallback(error))
      }
    })
  }

  /**
   * when day time is changed and updated, then hide conflict grid.
   */
  hideConflictGrid() {
    this.conflictData = {};
    this.conflictPaginationInfo = { totalRecords: 0 };
  }
}




// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-universal-operational-hours/adm-manage-universal-operational-hours.component.ts